import { P, match } from 'ts-pattern'

export const resolveImageSrc = (img: string | { src: string }) =>
  match(img)
    .with(P.string, (src) => src)
    .otherwise(({ src }) => src)
